import { ColumnModel, ConfigHeader, DataModel, FusionEntity, TableModel, User } from './index';
import { ReferenceTableModel } from './reference-table.model';

/* eslint-disable @typescript-eslint/naming-convention */
export interface FileModel {
	FileName: string;
	FileDisplayName: string;
	workFileId: string;
	FusionEntities: FusionEntity[];
	FusionDataColumns: ColumnModel[];
	FusionDataTables: TableModel[];
	TABLE_DATA: DataModel[] | any;
	FusionReferenceTables: ReferenceTableModel[];
	FusionUsers: User[];
	FusionConfigHeader: ConfigHeader[];
	apiConnectionId?: string;
}
